import React, { createContext, useContext, useState, useEffect } from 'react';
import { useEvent } from '@/store'; 
import useBoletiaConfig from '@/hooks/useBoletiaConfig'

const initialState = {
  toggleColorMode: () => {},
};

const ColorContext = createContext(initialState);

function ColorContextProvider({ children }) {
  const { event } = useEvent();
  const { eventColorMode } = useBoletiaConfig();
  const [mode, setMode] = useState('light');
  const toggleColorMode = (currentMode) => {
    if (currentMode === 'dark') {
      return setMode('dark');
    }
    return setMode('light');
  };

  useEffect(() => {
    if(event && event.event && event.event.id) {
      toggleColorMode(eventColorMode(event.event.id));
    }
  }, [event]);

  return (
    <ColorContext.Provider value={{ mode, toggleColorMode }}>
      {children}
    </ColorContext.Provider>
  );
}

const useColorContext = () => useContext(ColorContext);

export { ColorContextProvider, useColorContext, ColorContext };
